<template>
  <div>
    <CustomCallout
      :has-toggle="item.hasDetails"
      :opened="item.expanded"
      :controlled="true"
      :border-color="statusColor"
      @click:open="expand(item)"
    >
      <div class="row">
        <div
          class="col-sm-12 col-md-3 col-lg-2 py-3 border-right-2 d-flex flex-column align-items-start justify-content-start"
          style="position:relative;bottom: 5px;"
        >
          <custom-balloon
            class="px-4 p-2 mt-3 text-body"
            :text="item.serviceStatusName"
            :background-color="statusColor"
          />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-8 py-md-3 py-2 pl-md-5 pl-2">
          <div class="row">
            <div class="col-6 col-md-3 d-flex flex-column">
              <CustomInputDisplay
                label="Número de Referido:"
                label-class="text-gray font-weight-light"
                :value="item.referralNumber"
                class="font-weight-bold"
              />
            </div>
            <div class="col-6 col-md-3 d-flex flex-column">
              <CustomInputDisplay
                label="Estudiante:"
                label-class="text-gray font-weight-light"
                :value="studentSieAndFullName"
                class="font-weight-bold"
              />
            </div>
            <div class="col-6 col-md-3 d-flex flex-column">
              <div class="input-display font-weight-bold">
                <label class="text-gray font-weight-light">
                  Tipo/Fecha:
                </label>
                <div class="position-relative">
                  <label>
                    <strong class="font-weight-bolder">
                      {{ item.referralTypeName }}
                    </strong>
                    - {{ item.referralDate | date }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-3 d-flex flex-column">
              <CustomInputDisplay
                label="Centro:"
                label-class="text-gray font-weight-light"
                :value="item.serviceCenterName"
                class="font-weight-bold"
              />
            </div>
          </div>
        </div>
        <div
          v-if="showOptions"
          class="col-md-2 col-sm-12 d-flex align-items-center justify-content-center"
        >
          <DropDown :items="getMenuItems(item)" normal-size />
        </div>
      </div>
      <template #edition>
        <ValidationObserver ref="form" class="w-100">
          <div class="additional-container mt-1">
            <transition
              name="accordion"
              @before-enter="beforeEnter"
              @enter="enter"
              @before-leave="beforeLeave"
              @leave="leave"
            >
              <div
                v-if="
                  !item.showDocuments &&
                    !item.showReferralDocuments &&
                    !item.showMinutaAtDocument &&
                    !item.showGuaranteeDocuments &&
                    !item.showDocumentCommentHistory &&
                    !item.replaceDocuments &&
                    !item.showAddComment &&
                    !item.showReferralInfo &&
                    !item.showRevertEvaluationDiscussion
                "
                class="row w-100 m-0 grayish p-2 row-details"
              >
                <div class="col-md-12 bg-white rounded py-4">
                  <span class="w-100 pl-1 dark-gray font-weight-bolder">
                    <em class="fa fa-info-circle icon-orange" />
                    Información de Escuela del Estudiante
                  </span>

                  <div class="row mx-0 mt-4 px-2">
                    <div class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column">
                      <CustomInputDisplay
                        label="Región:"
                        label-class="text-gray font-weight-light"
                        :value="item.region"
                        class="font-weight-bold"
                      />
                    </div>
                    <div class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column">
                      <CustomInputDisplay
                        label="Distrito:"
                        label-class="text-gray font-weight-light"
                        :value="item.district"
                        class="font-weight-bold"
                      />
                    </div>
                    <div class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column">
                      <CustomInputDisplay
                        label="Municipio:"
                        label-class="text-gray font-weight-light"
                        :value="item.municipality"
                        class="font-weight-bold"
                      />
                    </div>
                    <div
                      class="col-6 col-md-3 mb-2 mb-md-0  d-flex flex-column"
                    >
                      <CustomInputDisplay
                        label="Escuela:"
                        label-class="text-gray font-weight-light"
                        :value="`${item.schoolCode} - ${item.schoolName}`"
                        class="font-weight-bold"
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-if="showInformationStatus"
                  class="col-md-12 bg-white rounded py-4 mt-2"
                >
                  <span class="w-100 pl-1 dark-gray font-weight-bolder">
                    <em class="fa fa-info-circle icon-orange" />
                    Información del Estatus
                  </span>
                  <div class="row mx-0 mt-4 px-2">
                    <div class="col-12 mb-2 mb-md-0  d-flex flex-column">
                      <CustomInputDisplay
                        label="Razón:"
                        label-class="text-gray font-weight-light"
                        :value="item.reasonName"
                        class="font-weight-bold"
                      />
                    </div>
                    <div class="col-12 mb-2 mb-md-0 d-flex flex-column mt-4">
                      <CustomInputDisplay
                        label="Comentario:"
                        label-class="text-gray font-weight-light"
                        :value="item.statusComment"
                        class="font-weight-bold"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <transition
              name="accordionDocs"
              @before-enter="beforeEnter"
              @enter="enter"
              @before-leave="beforeLeave"
              @leave="leave"
            >
              <div>
                <div
                  v-if="item.showDocuments"
                  class="row w-100 m-0 grayish p-2 row-details"
                >
                  <div class="col-md-12 bg-white rounded py-4">
                    <template>
                      <div
                        class="tag-badge-custom d-flex align-items-center pr-2 pl-1"
                      >
                        <span class="fa-stack fa-xs">
                          <em
                            class="far fa-circle fa-stack-2x double text-white"
                          />
                          <em class="fas fa-circle fa-stack-2x green" />
                          <em class="fas fa-file-user fa-stack-1x fa-inverse" />
                        </span>
                        <span class="py-1 pl-1 font-weight-bold mb-0">
                          Añadir Documento
                        </span>
                      </div>

                      <div class="row mx-0 mt-5 px-2">
                        <div class="col-12">
                          <div class="row mx-0 pl-4 mb-5">
                            <div
                              class="col-md-3 pl-0 pl-md-2 d-flex flex-column"
                            >
                              <strong class="mb-3 document-label">
                                Documento
                              </strong>
                              <span class="document-description">
                                Estipulación 80 Firmada
                              </span>
                            </div>
                            <div
                              class="col-12 col-md-4 d-flex flex-column mt-3 mt-md-0"
                            >
                              <strong class="mb-1 document-label">
                                Archivo
                              </strong>

                              <div
                                v-if="
                                  item.estipulacion80 &&
                                    item.estipulacion80.documentTitle
                                "
                                class="row"
                              >
                                <div class="col-8 d-flex align-items-center">
                                  <span class="file-name text-underline">
                                    {{ item.estipulacion80.documentTitle }}
                                  </span>
                                </div>
                                <div class="col-4">
                                  <action-button
                                    v-if="item.estipulacion80.uploaded"
                                    type="submit"
                                    text=""
                                    i="fa fa-file-download pl-2"
                                    variant="outline-success"
                                    class="px-1 mr-2 actions"
                                    @click="
                                      downloadDocument(item, 'estipulacion80')
                                    "
                                  />
                                  <action-button
                                    v-if="canDeleteDocument(item)"
                                    type="submit"
                                    text=""
                                    i="fa fa-times-circle pl-2"
                                    variant="outline-danger"
                                    class="px-1 actions"
                                    @click="
                                      deleteOrDiscard(item, 'estipulacion80')
                                    "
                                  />
                                </div>
                              </div>

                              <button
                                v-else
                                class="btn bg-light-white btn-addFile btn-anejar"
                                for="file"
                                @click="openFile('estipulacion80')"
                              >
                                <i
                                  class="fas fa-file-plus text-green pr-1 fa-lg"
                                />
                                <span class="ml-2">
                                  Presione aquí para anejar documento
                                </span>
                              </button>
                              <input
                                id="fileEstipulacion80"
                                ref="fileEstipulacion80"
                                type="file"
                                :disabled="atCompletedFlag"
                                style="display:none;"
                                accept="application/pdf"
                                @change="onFileSelected(item, 'estipulacion80')"
                              />
                            </div>
                          </div>
                          <div class="row mx-0 pl-4 mb-5">
                            <div
                              class="col-md-3 pl-0 pl-md-2 d-flex flex-column"
                            >
                              <strong class="mb-3 document-label">
                                Documento
                              </strong>
                              <span class="document-description">
                                Minuta de Entrega de Equipo Firmada
                              </span>
                            </div>
                            <div
                              class="col-12 col-md-4 d-flex flex-column mt-3 mt-md-0"
                            >
                              <strong class="mb-1 document-label">
                                Archivo
                              </strong>

                              <div
                                v-if="item.minuta && item.minuta.documentTitle"
                                class="row"
                              >
                                <div class="col-8 d-flex align-items-center">
                                  <span class="file-name text-underline">
                                    {{ item.minuta.documentTitle }}
                                  </span>
                                </div>
                                <div class="col-4">
                                  <action-button
                                    v-if="item.minuta.uploaded"
                                    type="submit"
                                    text=""
                                    i="fa fa-file-download pl-2"
                                    variant="outline-success"
                                    class="px-1 mr-2 actions"
                                    @click="downloadDocument(item, 'minuta')"
                                  />
                                  <action-button
                                    v-if="canDeleteDocument(item)"
                                    type="submit"
                                    text=""
                                    i="fa fa-times-circle pl-2"
                                    variant="outline-danger actions"
                                    class="px-1"
                                    @click="deleteOrDiscard(item, 'minuta')"
                                  />
                                </div>
                              </div>

                              <button
                                v-else
                                class="btn bg-light-white btn-addFile btn-anejar"
                                for="file"
                                @click="openFile('minuta')"
                              >
                                <i
                                  class="fas fa-file-plus text-green pr-1 fa-lg"
                                />
                                <span class="ml-2">
                                  Presione aquí para anejar documento
                                </span>
                              </button>

                              <input
                                id="fileMinuta"
                                ref="fileMinuta"
                                type="file"
                                :disabled="atCompletedFlag"
                                style="display:none;"
                                accept="application/pdf"
                                @change="onFileSelected(item, 'minuta')"
                              />
                            </div>
                          </div>
                          <div
                            class="row mx-0 pl-4 mb-5"
                            v-if="isDeliveredPendingSignatureStatus"
                          >
                            <div
                              class="col-md-3 pl-0 pl-md-2 d-flex flex-column"
                            >
                              <strong class="mb-3 document-label">
                                Documento
                              </strong>
                              <span class="document-description">
                                PEI Firmado
                              </span>
                            </div>
                            <div
                              class="col-12 col-md-4 d-flex flex-column mt-3 mt-md-0"
                            >
                              <div v-if="hasSignedPei" class="row">
                                <div
                                  class="col-12 col-md-4 pl-0 pl-md-2 d-flex flex-column"
                                >
                                  <span class="mb-2 document-title">
                                    Tipo de Documento:
                                  </span>
                                  <span class="document-description">
                                    PEI Firmado
                                  </span>
                                </div>
                                <div class="col-s,">
                                  <action-button
                                    type="button"
                                    i="fa fa-download pl-2"
                                    variant="outline-success"
                                    class="px-1 mr-2 actions"
                                    @click="getSignedPeiDocument()"
                                  />
                                </div>
                              </div>
                              <div v-else>
                                <div
                                  class=" alert alert-warning text-danger responsive-max-width"
                                >
                                  <i class="fas fa-bell-exclamation mr-1" />
                                  Para obtener el documento de PEI firmado debe
                                  dirigirse a la enmienda de PEI creada en
                                  estatus completado para llevarlo a Firmado.
                                  <a
                                    class="link"
                                    @click="goToStudentPeiHistory"
                                  >
                                    Ir al PEI.
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-content-end">
                            <div
                              v-if="canShowSaveCancelButtons(item)"
                              class="col-md-5 mt-3 mt-md-0 col-12 d-flex justify-content-end align-items-center px-0"
                            >
                              <action-button
                                type="submit"
                                text="Cancelar"
                                i="fa fa-times-circle"
                                variant="outline-danger m-2"
                                class="ml-2 px-4"
                                @click="hideDocuments(item)"
                              />

                              <action-button
                                type="submit"
                                text="Guardar"
                                variant="success"
                                class="ml-2 px-4"
                                @click="saveDocuments(item)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <attach-discussion-document
                  v-if="item.showMinutaAtDocument"
                  title="Añadir Documento de Discusión"
                  background-class="bg-white"
                  :student-sie="item?.studentSieId"
                  :pei-at-service-id="item?.peiAtServiceId"
                  :is-signed-pending="isDiscussedSignPendingStatus"
                  :minuteFileName="getMinuteDocFilename(item)"
                  :documents="getMinuteDocuments(item)"
                  @on-save-document="onSaveDocument($event, item)"
                  @downloadAtDocument="
                    DownloadAtReferralDocument(
                      item.peiAtServiceId,
                      getMinuteDocuments(item)[0]
                    )
                  "
                  @on-cancel-add-document="hideMinutaAtDocument(item)"
                />
                <div
                  v-if="item.showReferralDocuments"
                  class="row w-100 m-0 grayish p-2 row-details"
                >
                  <div class="col-md-12 bg-white rounded py-4">
                    <template>
                      <div
                        class="tag-badge-custom d-flex align-items-center pr-2 pl-1"
                      >
                        <span class="fa-stack fa-xs">
                          <em
                            class="far fa-circle fa-stack-2x double text-white"
                          />
                          <em class="fas fa-circle fa-stack-2x green" />
                          <em class="fas fa-file-user fa-stack-1x fa-inverse" />
                        </span>
                        <span class="py-1 pl-1 font-weight-bold mb-0">
                          Documentos
                        </span>
                      </div>

                      <div v-if="item.peiId != null" class="row mx-0 mt-4 px-2">
                        <div class="col-12">
                          <div class="row mx-0 pl-4">
                            <div
                              class="col-md-4 pl-0 pl-md-2 d-flex flex-column"
                            >
                              <strong class="mb-1 document-label">
                                Tipo de documento:
                              </strong>
                              <span class="document-description">
                                Guía de Referidos de AT
                              </span>
                            </div>
                            <div
                              class="col-md-6 pl-0 pl-md-2 d-flex flex-column"
                            >
                              <strong class="mb-1 document-label">
                                Archivo:
                              </strong>
                              <span class="document-description">
                                Guía de Referidos de AT
                              </span>
                            </div>
                            <div
                              class="col-2 col-md-2 d-flex flex-column mt-3 mt-md-0"
                            >
                              <action-button
                                type="submit"
                                text="Ver Documento"
                                i="fa fa-file-search pl-2"
                                variant="outline-success"
                                class="px-1 mr-2"
                                @click="getAtServiceReport(item)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-for="document in item.documents"
                        :key="document.DocumentId"
                        class="row mx-0 mt-4 px-2"
                      >
                        <div class="col-12">
                          <div class="row mx-0 pl-4">
                            <div
                              class="col-md-4 pl-0 pl-md-2 d-flex flex-column"
                            >
                              <strong class="mb-1 document-label">
                                Tipo de documento:
                              </strong>
                              <span class="document-description">
                                {{ document.documentTypeName }}
                              </span>
                            </div>

                            <div
                              class="col-md-6 pl-0 pl-md-2 d-flex flex-column"
                            >
                              <strong class="mb-1 document-label">
                                Archivo:
                              </strong>
                              <span class="document-description">
                                {{ document.filename }}
                              </span>
                            </div>
                            <div
                              class="col-2 col-md-2 d-flex flex-column mt-3 mt-md-0"
                            >
                              <action-button
                                type="submit"
                                text="Ver Documento"
                                i="fa fa-file-search pl-2"
                                variant="outline-success"
                                class="px-1 mr-2"
                                @click="
                                  DownloadAtReferralDocument(
                                    item.peiAtServiceId,
                                    document
                                  )
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <guarantee-documents
                  v-if="item.showGuaranteeDocuments"
                  :pei-at-service-id="item?.peiAtServiceId"
                  :student-sie-id="item?.studentSieId"
                />

                <document-comment-history
                  v-if="item.showDocumentCommentHistory"
                  :comments="item.documentComments"
                />

                <referral-info-panel
                  v-if="item.showReferralInfo"
                  :pei-at-service-id="item?.peiAtServiceId"
                />

                <add-comment-form
                  v-if="item.showAddComment"
                  @cancel="onCancelAddCommentHandler(item)"
                  @submit="onSaveAddCommentHandler($event, item)"
                />
                <div
                  v-if="item.replaceDocuments"
                  class="row w-100 m-0 grayish p-2 row-details"
                >
                  <div class="col-md-12 bg-white rounded py-4">
                    <template>
                      <div
                        class="tag-badge-custom d-flex align-items-center pr-2 pl-1"
                      >
                        <span class="fa-stack fa-xs">
                          <em
                            class="far fa-circle fa-stack-2x double text-white"
                          />
                          <em class="fas fa-circle fa-stack-2x green" />
                          <em class="fas fa-file-user fa-stack-1x fa-inverse" />
                        </span>
                        <span class="py-1 pl-1 font-weight-bold mb-0">
                          Editar Documento
                        </span>
                      </div>

                      <div class="row mx-0 mt-4 px-2">
                        <div class="col-12">
                          <div
                            v-if="
                              item.estipulacion80 && canReplaceMinutaDiscusion
                            "
                            class="row mx-0 pl-4 mb-5"
                          >
                            <div
                              class="col-md-3 pl-0 pl-md-2 d-flex flex-column"
                            >
                              <strong class="mb-3 document-label">
                                Documento
                              </strong>
                              <span class="document-description">
                                Estipulación 80 Firmada
                              </span>
                            </div>
                            <div
                              class="col-12 col-md-4 d-flex flex-column mt-3 mt-md-0"
                            >
                              <strong class="mb-1 document-label">
                                Archivo
                              </strong>

                              <div
                                v-if="
                                  item.estipulacion80 &&
                                    item.estipulacion80.documentTitle
                                "
                                class="row"
                              >
                                <div class="col-8 d-flex align-items-center">
                                  <span class="file-name text-underline">
                                    {{ item.estipulacion80.documentTitle }}
                                  </span>
                                </div>
                                <div class="col-4">
                                  <action-button
                                    v-if="item.estipulacion80.uploaded"
                                    type="submit"
                                    text=""
                                    i="fa fa-file-download pl-2"
                                    variant="outline-success"
                                    class="px-1 mr-2 actions"
                                    @click="
                                      downloadDocument(item, 'estipulacion80')
                                    "
                                  />
                                  <action-button
                                    type="submit"
                                    text=""
                                    i="fa fa-times-circle pl-2"
                                    variant="outline-danger"
                                    class="px-1 actions"
                                    @click="
                                      discardSelectedFile(
                                        item,
                                        'estipulacion80'
                                      )
                                    "
                                  />
                                </div>
                              </div>

                              <button
                                v-else
                                class="btn bg-light-white btn-addFile btn-anejar"
                                for="file"
                                @click="openFile('estipulacion80')"
                              >
                                <i
                                  class="fas fa-file-plus text-green pr-1 fa-lg"
                                />
                                <span class="ml-2">
                                  Presione aquí para anejar documento
                                </span>
                              </button>
                              <input
                                id="fileEstipulacion80"
                                ref="fileEstipulacion80"
                                type="file"
                                :disabled="atCompletedFlag"
                                style="display:none;"
                                accept="application/pdf"
                                @change="onFileSelected(item, 'estipulacion80')"
                              />
                            </div>
                            <div
                              class="col-12 w-100 pl-0 mt-2"
                              v-if="comments.estipulacion80.enabled"
                            >
                              <ValidationProvider
                                v-slot="{ errors }"
                                slim
                                rules="required"
                                name="Comments"
                              >
                                <custom-text-area
                                  v-model="comments.estipulacion80.text"
                                  label="Comentario"
                                  required
                                  :maxlength="3000"
                                  :error="`${errors[0] ? 'error' : ''}`"
                                  custom-error-msg="Favor de documentar el comentario."
                                  class="w-100 pl-2"
                                  :show-char-count="true"
                                />
                              </ValidationProvider>
                            </div>
                          </div>
                          <div
                            v-if="item.minuta && canReplaceMinutaDiscusion"
                            class="row mx-0 pl-4 mb-5"
                          >
                            <div
                              class="col-md-3 pl-0 pl-md-2 d-flex flex-column"
                            >
                              <strong class="mb-3 document-label">
                                Documento
                              </strong>
                              <span class="document-description">
                                Minuta de Entrega de Equipo Firmada
                              </span>
                            </div>
                            <div
                              class="col-12 col-md-4 d-flex flex-column mt-3 mt-md-0"
                            >
                              <strong class="mb-1 document-label">
                                Archivo
                              </strong>

                              <div
                                v-if="item.minuta && item.minuta.documentTitle"
                                class="row"
                              >
                                <div class="col-8 d-flex align-items-center">
                                  <span class="file-name text-underline">
                                    {{ item.minuta.documentTitle }}
                                  </span>
                                </div>
                                <div class="col-4">
                                  <action-button
                                    v-if="item.minuta.uploaded"
                                    type="submit"
                                    text=""
                                    i="fa fa-file-download pl-2"
                                    variant="outline-success"
                                    class="px-1 mr-2 actions"
                                    @click="downloadDocument(item, 'minuta')"
                                  />
                                  <action-button
                                    type="submit"
                                    text=""
                                    i="fa fa-times-circle pl-2"
                                    variant="outline-danger actions"
                                    class="px-1"
                                    @click="discardSelectedFile(item, 'minuta')"
                                  />
                                </div>
                              </div>

                              <button
                                v-else
                                class="btn bg-light-white btn-addFile btn-anejar"
                                for="file"
                                @click="openFile('minuta')"
                              >
                                <i
                                  class="fas fa-file-plus text-green pr-1 fa-lg"
                                />
                                <span class="ml-2">
                                  Presione aquí para anejar documento
                                </span>
                              </button>

                              <input
                                id="fileMinuta"
                                ref="fileMinuta"
                                type="file"
                                :disabled="atCompletedFlag"
                                style="display:none;"
                                accept="application/pdf"
                                @change="onFileSelected(item, 'minuta')"
                              />
                            </div>
                            <div
                              class="col-12 w-100 pl-0 mt-2"
                              v-if="comments.minuta.enabled"
                            >
                              <ValidationProvider
                                v-slot="{ errors }"
                                slim
                                rules="required"
                                name="Comments"
                              >
                                <custom-text-area
                                  v-model="comments.minuta.text"
                                  label="Comentario"
                                  required
                                  :maxlength="3000"
                                  :error="`${errors[0] ? 'error' : ''}`"
                                  custom-error-msg="Favor de documentar el comentario."
                                  class="w-100 pl-2"
                                  :show-char-count="true"
                                />
                              </ValidationProvider>
                            </div>
                          </div>
                          <div
                            v-if="
                              item.minutaDiscusionEvaluacion &&
                                canReplaceEvaluationDiscussion
                            "
                            class="row mx-0 pl-4 mb-5"
                          >
                            <div
                              class="col-md-3 pl-0 pl-md-2 d-flex flex-column"
                            >
                              <strong class="mb-3 document-label">
                                Documento
                              </strong>
                              <span class="document-description">
                                Minuta de Discusión de Evaluación de AT Firmada
                              </span>
                            </div>
                            <div
                              class="col-12 col-md-4 d-flex flex-column mt-3 mt-md-0"
                            >
                              <strong class="mb-1 document-label">
                                Archivo
                              </strong>

                              <div
                                v-if="
                                  item.minutaDiscusionEvaluacion &&
                                    item.minutaDiscusionEvaluacion.documentTitle
                                "
                                class="row"
                              >
                                <div class="col-8 d-flex align-items-center">
                                  <span class="file-name text-underline">
                                    {{
                                      item.minutaDiscusionEvaluacion
                                        .documentTitle
                                    }}
                                  </span>
                                </div>
                                <div class="col-4">
                                  <action-button
                                    v-if="
                                      item.minutaDiscusionEvaluacion.uploaded
                                    "
                                    type="submit"
                                    text=""
                                    i="fa fa-file-download pl-2"
                                    variant="outline-success"
                                    class="px-1 mr-2 actions"
                                    @click="
                                      downloadDocument(
                                        item,
                                        'minutaDiscusionEvaluacion'
                                      )
                                    "
                                  />
                                  <action-button
                                    type="submit"
                                    text=""
                                    i="fa fa-times-circle pl-2"
                                    variant="outline-danger actions"
                                    class="px-1"
                                    @click="
                                      discardSelectedFile(
                                        item,
                                        'minutaDiscusionEvaluacion'
                                      )
                                    "
                                  />
                                </div>
                              </div>

                              <button
                                v-else
                                class="btn bg-light-white btn-addFile btn-anejar"
                                for="file"
                                @click="openFile('minutaDiscusionEvaluacion')"
                              >
                                <i
                                  class="fas fa-file-plus text-green pr-1 fa-lg"
                                />
                                <span class="ml-2">
                                  Presione aquí para anejar documento
                                </span>
                              </button>

                              <input
                                id="fileMinutaDiscusionEvaluacion"
                                ref="fileMinutaDiscusionEvaluacion"
                                type="file"
                                :disabled="atCompletedFlag"
                                style="display:none;"
                                accept="application/pdf"
                                @change="
                                  onFileSelected(
                                    item,
                                    'minutaDiscusionEvaluacion'
                                  )
                                "
                              />
                            </div>
                            <div
                              class="col-12 w-100 pl-0 mt-2"
                              v-if="comments.minutaDiscusionEvaluacion.enabled"
                            >
                              <ValidationProvider
                                v-slot="{ errors }"
                                slim
                                rules="required"
                                name="Comments"
                              >
                                <custom-text-area
                                  v-model="
                                    comments.minutaDiscusionEvaluacion.text
                                  "
                                  label="Comentario"
                                  required
                                  :maxlength="3000"
                                  :error="`${errors[0] ? 'error' : ''}`"
                                  custom-error-msg="Favor de documentar el comentario."
                                  class="w-100 pl-2"
                                  :show-char-count="true"
                                />
                              </ValidationProvider>
                            </div>
                          </div>
                          <div class="row mx-0 pl-4 mb-2">
                            <div
                              class="col-12 mt-md-0 d-flex justify-content-end px-0"
                            >
                              <div class="d-flex">
                                <action-button
                                  type="submit"
                                  text="Cancelar"
                                  i="fa fa-times-circle"
                                  variant="outline-danger"
                                  class="ml-2 px-4"
                                  @click="hideDocuments(item)"
                                />

                                <action-button
                                  type="submit"
                                  text="Guardar"
                                  variant="success"
                                  class="ml-2 px-4"
                                  @click="saveReplacedDocuments(item)"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </ValidationObserver>
        <div
          v-if="item.showRevertEvaluationDiscussion"
          class="revert-evaluation-discussion-section-wrapper row mx-auto p-2"
        >
          <div
            class="revert-evaluation-discussion-comment col-12 row mx-auto p-3 bg-white"
          >
            <div class="col-12">
              <em class="fas fa-reply-all text-green mr-2" />
              <span class="input-label font-16">Revertir</span>
            </div>
            <validation-observer
              class="col-12"
              ref="revertEvaluationDiscussionFormValidator"
            >
              <div class="d-flex flex-direction mt-3">
                <validation-provider
                  v-slot="{ errors }"
                  class="flex-grow-2"
                  rules="required"
                >
                  <div>
                    <label>Comentario:</label>
                    <CustomTextArea
                      type="text"
                      v-model="revertEvaluationDiscussionComment"
                      :show-char-count="true"
                      :error="errors[0]"
                      custom-error-msg="El campo es requerido."
                      :maxlength="3000"
                    />
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
            <div class="col-12 d-flex justify-content-end mt-4">
              <action-button
                variant="danger mr-2"
                i="fas fa-times-circle"
                text="Cancelar"
                @click="onCancelRevertEvaluationDiscussionHandler(item)"
              />
              <action-button
                variant="success mr-2"
                i="fas fa-save"
                text="Guardar"
                @click="onSaveRevertEvaluationDiscussionHandler(item)"
              />
            </div>
          </div>
        </div>
      </template>
    </CustomCallout>
  </div>
</template>

<script>
import generalService from '@/services/pei/general';
import { http } from '@/core/api/';

import mixWait from '@/mixin/loading.mixin';
import mixAlert from '@/mixin/alert.mixin';

import store from '@/store/index';
import router from '@/router/index';
import {
  peiAtServiceStatus,
  getStatusColor,
} from '@/utils/constants/at/peiAtServiceStatus';
import referralTypes from '@/utils/constants/pei/referral/referralTypes';
import CustomBalloon from 'custom-balloon';
import CustomCallout from 'custom-callout';
import CustomTextArea from 'CustomTextArea';
import DropDown from 'dropdown';
import ActionButton from 'ActionButton';
import CustomInputDisplay from 'CustomInputDisplay';
import documentTypes from '@/utils/constants/documentTypes.js';
import AttachDiscussionDocument from '@/components/at/evaluationdiscussionAT/components/AttachDiscussionDocument';
import atService from '@/services/pei/at';
import objectToFormData from 'object-to-formdata';
import DocumentsService from '@/services/documents';
import studentService from '@/services/student';
import GuaranteeDocuments from './GuaranteeDocuments';
import DocumentCommentHistory from './DocumentCommentHistory';
import ReferralInfoPanel from './ReferralInfoPanel';
import { AddCommentForm } from '@quisit/comments';
import commentTypes from '@/utils/constants/comment/commentTypes';

const equipmentDocumentTypes = {
  MINUTADISCUSIONEVALUACION: 16,
  ESTIPULACION80: 18,
  MINUTA: 19,
};

export default {
  name: 'ResultRow',
  mixins: [mixWait, mixAlert],
  components: {
    DropDown,
    ActionButton,
    CustomCallout,
    CustomBalloon,
    CustomTextArea,
    CustomInputDisplay,
    AttachDiscussionDocument,
    GuaranteeDocuments,
    DocumentCommentHistory,
    ReferralInfoPanel,
    AddCommentForm,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    search: {
      type: Function,
      default: () => undefined,
    },
  },
  data() {
    return {
      revertEvaluationDiscussionComment: null,
      canReplaceEvaluationDiscussion: false,
      canReplaceMinutaDiscusion: false,
      page: {
        icon: 'fas fa-user-edit',
        title: 'PEI: Referidos de Asistencia Tecnológica',
        routes: ['Inicio', 'PEI', 'Referidos de Asistencia Tecnológica'],
      },
      ReferralType: [],
      DocumentAttachments: [],
      atCompletedFlag: false,
      signedPeiDocumentId: null,
      student: null,
      comments: {
        estipulacion80: {
          text: null,
          enabled: false,
        },
        minuta: {
          text: null,
          enabled: false,
        },
        minutaDiscusionEvaluacion: {
          text: null,
          enabled: false,
        },
      },
    };
  },
  async mounted() {
    await this.getStudent();
  },
  computed: {
    hasRevertDiscussionPermission() {
      return this.userHasPermissions(
        'menu.technologyassistancereferrals.minutediscussiondoc.revert'
      );
    },
    isDiscussedSignPendingStatus() {
      return (
        this.item.serviceStatusId ==
        peiAtServiceStatus.DiscutidoPendienteDeFirma
      );
    },
    isDeliveredPendingSignatureStatus() {
      return (
        this.item.serviceStatusId == peiAtServiceStatus.EntregadoPendienteFirma
      );
    },
    statusColor() {
      return getStatusColor(this.item.serviceStatusId);
    },
    canRevertReferral() {
      return (
        this.isDeliveredPendingSignatureStatus &&
        this.userHasPermissions(
          'menu.technologyassistancereferralsEschooldiscussiondo.revert'
        )
      );
    },
    showInformationStatus() {
      return this.showIfContainStatus(
        [peiAtServiceStatus.Denegado, peiAtServiceStatus.Ajustado],
        this.item.serviceStatusId
      );
    },
    showOptions() {
      return this.getMenuItems(this.item).some((x) => x.visible);
    },
    studentSieAndFullName() {
      return `${this.item.studentSieId} - ${this.item.studentName}`;
    },
    hasSignedPei() {
      return (
        this.signedPeiDocumentId !== null &&
        this.signedPeiDocumentId != '' &&
        this.signedPeiDocumentId != undefined
      );
    },
  },
  methods: {
    getMinuteDocFilename(item) {
      let filename = '';

      var minuteDocs = this.getMinuteDocuments(item);
      if (minuteDocs.length) {
        filename = minuteDocs[0]?.filename;
      }

      return filename;
    },
    getMinuteDocuments(item) {
      return (
        item?.documents?.filter(
          (x) => x.documentTypeId == documentTypes.MinutaDiscussionSigned
        ) ?? []
      );
    },
    getMenuItems(item) {
      let items = [
        {
          name: 'Ver Referido de Solicitud', // Solo para dos tipos de referidos 7 y 8
          icon: 'fas fa-file-invoice text-green',
          visible: this.canGoToReferralTypes(item.referralTypeId),
          click: () => this.goToReferralRequest(item.peiAtServiceId),
        },
        {
          name: 'Información del Referido',
          icon: 'fas fa-info-circle text-green',
          click: () => this.showReferralInfoPanel(item),
        },
        {
          name: 'Discusión de la Evaluación', // Status 8 o hasSubmittedDiscuss
          icon: 'fas fa-search-plus text-green',
          visible:
            item.serviceStatusId === peiAtServiceStatus.PendienteDeDiscusion ||
            item.hasSubmittedDiscuss,
          click: () => this.goToEvaluationDiscution(item),
        },
        {
          name: 'Revertir Discusión', // Status 25
          icon: 'fas fa-reply-all text-green',
          visible:
            item.serviceStatusId ===
              peiAtServiceStatus.DiscutidoPendienteDeFirma &&
            this.hasRevertDiscussionPermission,
          click: () => this.showRevertEvaluationDiscussionPanel(item),
        },
        {
          name: 'Revertir Discusión Escuela',

          icon: 'fas fa-reply-all text-green',
          visible: this.canRevertReferral,
          click: () => this.showRevertEvaluationDiscussionPanel(item),
        },
        {
          name: 'Discusión en Escuela', //Status == 13, 14, 22, 26
          icon: 'fas fa-book-reader text-green',
          visible: [
            peiAtServiceStatus.PendienteDeDiscusionEscuela,
            peiAtServiceStatus.Servido,
            peiAtServiceStatus.PendienteDeServicio,
            peiAtServiceStatus.EntregadoPendienteFirma,
          ].includes(item.serviceStatusId),
          click: () => this.goToReferralAtDiscussionSchool(item),
        },
        {
          name: 'Añadir Comentario',
          icon: 'fas fa-comment text-green',
          click: () => this.showAddCommentPanel(item),
        },
        {
          name: 'Anejar Minuta de Discusion de Evaluacion', //Status = 26 y hasSubmittedDiscuss
          icon: 'fas fa-plus-circle text-green',
          visible:
            [
              peiAtServiceStatus.PendienteDeDiscusion,
              peiAtServiceStatus.DiscutidoPendienteDeFirma,
            ].includes(item.serviceStatusId) && item.hasSubmittedDiscuss,
          click: () => this.showMinutaAtDocument(item),
        },
        {
          name: 'Anejar Documentos de Entrega de Equipo', //Status = 13,26 y hasServedSchoolDate
          icon: 'fas fa-plus-circle text-green',
          visible:
            [
              peiAtServiceStatus.PendienteDeDiscusionEscuela,
              peiAtServiceStatus.EntregadoPendienteFirma,
            ].includes(item.serviceStatusId) && item.hasServedSchoolDate,
          click: () => this.showDocuments(item),
        },
        {
          name: 'Ver Documentos de Entrega de Equipo', //Status = 14 y hasServedSchoolDate
          icon: 'fas fa-file-download text-green',
          visible:
            item.serviceStatusId === peiAtServiceStatus.Servido &&
            item.hasServedSchoolDate,
          click: () => this.showDocuments(item),
        },
        {
          name: 'Ver Documentos',
          icon: 'fas fa-file-download text-green',
          visible: true,
          click: () => this.showReferralDocuments(item),
        },
        {
          name: 'Comentario',
          icon: 'fas fa-file-alt text-green',
          visible: true,
          click: () =>
            this.$router.push({
              path: `/student/comments/commentshistory/${item.studentSieId}/${commentTypes.ReferidosAsistenciaTecnologica}`,
            }),
        },
        {
          name: 'Ver Documentos de Uso',
          visible: item.hasGuaranteeDocuments,
          icon: 'fas fa-file-download text-green',
          click: () => this.showGuaranteeeDocuments(item),
        },
        {
          name: 'Reemplazar Documento',
          icon: 'fas fa-repeat text-green',
          visible: this.canReplaceEvaluationDiscussionDocument(item),
          click: () => this.replaceDocuments(item),
        },
        {
          name: 'Ver Comentarios de Documentos',
          icon: 'fas fa-comment text-green',
          visible: this.canReplaceEvaluationDiscussionDocument(item),
          click: () => this.showDocumentCommentHistory(item),
        },
      ];

      return items;
    },

    replaceDocuments(item) {
      item.expanded = true;
      item.showDocuments = false;
      item.replaceDocuments = true;
      item.showReferralDocuments = false;
      item.showMinutaAtDocument = false;
      item.showGuaranteeDocuments = false;
      item.showDocumentCommentHistory = false;
      item.showAddComment = false;
      item.showReferralInfo = false;

      this.clearComments();

      this.loadDocumentsForReferral(item);
    },

    canReplaceEvaluationDiscussionDocument(item) {
      this.canReplaceEvaluationDiscussion =
        this.userHasPermissions(
          'menu.technologyassistancereferrals.view.evaluationDiscussion.replace'
        ) &&
        item.documents.some(
          (doc) =>
            doc.documentTypeId ===
            equipmentDocumentTypes.MINUTADISCUSIONEVALUACION
        );
      this.canReplaceMinutaDiscusion =
        this.userHasPermissions(
          'pei.technologyassistancereferrals.replacementdocument.pendingschooldiscussion'
        ) &&
        item.documents.some(
          (doc) =>
            doc.documentTypeId === equipmentDocumentTypes.MINUTA ||
            doc.documentTypeId === equipmentDocumentTypes.ESTIPULACION80
        );
      return (
        this.canReplaceEvaluationDiscussion || this.canReplaceMinutaDiscusion
      );
    },

    canGoToReferralTypes(referralTypeId) {
      const typesAllowed = [
        referralTypes.solicitudServicioRelacionadoEquipo,
        referralTypes.solicitudServicioAsistenciaTecnica,
      ];
      return typesAllowed.includes(referralTypeId);
    },
    expand(item) {
      item.expanded = !item.expanded;
      item.showDocuments = false;
      item.showReferralDocuments = false;
      item.replaceDocuments = false;
      item.showGuaranteeDocuments = false;
      item.showDocumentCommentHistory = false;
      item.showAddComment = false;
      item.showReferralInfo = false;
    },
    async showDocuments(item) {
      await this.validatePeiSigned();

      item.expanded = true;
      item.showDocuments = true;
      item.showReferralDocuments = false;
      item.showMinutaAtDocument = false;
      item.showGuaranteeDocuments = false;
      item.showDocumentCommentHistory = false;
      item.replaceDocuments = false;
      item.showAddComment = false;
      item.showReferralInfo = false;

      if (!item.estipulacion80 && !item.minuta) {
        this.loadDocumentsForReferral(item);
      }
    },
    showReferralDocuments(item) {
      item.expanded = true;
      item.showMinutaAtDocument = false;
      item.showDocuments = false;
      item.showReferralDocuments = true;
      item.replaceDocuments = false;
      item.showGuaranteeDocuments = false;
      item.showDocumentCommentHistory = false;
      item.showAddComment = false;
      item.showReferralInfo = false;
    },
    showGuaranteeeDocuments(item) {
      item.expanded = true;
      item.showMinutaAtDocument = false;
      item.showDocuments = false;
      item.showReferralDocuments = false;
      item.replaceDocuments = false;
      item.showGuaranteeDocuments = true;
      item.showAddComment = false;
      item.showDocumentCommentHistory = false;
      item.showReferralInfo = false;
    },
    showDocumentCommentHistory(item) {
      item.expanded = true;
      item.showMinutaAtDocument = false;
      item.showDocuments = false;
      item.showReferralDocuments = false;
      item.replaceDocuments = false;
      item.showAddComment = false;
      item.showGuaranteeDocuments = false;
      item.showReferralInfo = false;
      item.showDocumentCommentHistory = true;
    },
    showAddCommentPanel(item) {
      item.expanded = true;
      item.showAddComment = true;
      item.showMinutaAtDocument = false;
      item.showDocuments = false;
      item.showReferralDocuments = false;
      item.replaceDocuments = false;
      item.showGuaranteeDocuments = false;
      item.showDocumentCommentHistory = false;
      item.showReferralInfo = false;
    },
    showReferralInfoPanel(item) {
      item.expanded = true;
      item.showAddComment = false;
      item.showMinutaAtDocument = false;
      item.showDocuments = false;
      item.showReferralDocuments = false;
      item.replaceDocuments = false;
      item.showGuaranteeDocuments = false;
      item.showDocumentCommentHistory = false;
      item.showReferralInfo = true;
    },
    showRevertEvaluationDiscussionPanel(item) {
      item.expanded = true;
      item.showRevertEvaluationDiscussion = true;
      item.showAddComment = false;
      item.showMinutaAtDocument = false;
      item.showDocuments = false;
      item.showReferralDocuments = false;
      item.replaceDocuments = false;
      item.showGuaranteeDocuments = false;
      item.showDocumentCommentHistory = false;
      item.showReferralInfo = false;
    },
    async showMinutaAtDocument(item) {
      await this.validatePeiSigned();

      item.showReferralDocuments = false;
      item.expanded = true;
      item.showMinutaAtDocument = true;
      item.replaceDocuments = false;
      item.showGuaranteeDocuments = false;
      item.showAddComment = false;
      item.showDocumentCommentHistory = false;
      item.showReferralInfo = false;

      if (!item.minutaDiscusionEvaluacion) {
        this.loadDocumentsForReferral(item);
      }
    },
    hideDocuments(item) {
      item.expanded = false;
      item.showDocuments = false;

      this.clearComments();
    },
    clearComments() {
      Object.keys(this.comments).forEach((documentType) => {
        this.comments[documentType].text = null;
        this.comments[documentType].enabled = false;
      });
    },
    hideMinutaAtDocument(item) {
      item.expanded = false;
      item.showMinutaAtDocument = false;
    },
    beforeEnter: function(el) {
      el.style.height = '0';
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave: function(el) {
      el.style.height = '0';
    },
    DownloadAtReferralDocument(peiAtServiceId, document) {
      if (
        document.documentTypeId == documentTypes.MinuteReferralEvaluationAt ||
        (document.documentTypeId == documentTypes.MinutaDiscussionSigned &&
          document.filename)
      ) {
        this.DownloadDocument(peiAtServiceId, document.documentTypeId);
        return;
      }
      generalService.downloadDocument(document);
    },
    DownloadDocument(peiAtServiceId, codeDocumentType) {
      generalService.documentsDownloadFiles(peiAtServiceId, codeDocumentType);
    },
    GetDocumentAttachments(peiAtServiceId) {
      this.$ApiGet(`api/atservice/documentAttachments/${peiAtServiceId}`).then(
        (response) => {
          this.DocumentAttachments = response.data;
        }
      );
    },
    goToReferralRequest(peiAtServiceId) {
      this.$router.push({
        name: 'RequestTechAssistanceServices',
        params: {
          id: peiAtServiceId,
          studentSieId: this.student.studentId,
          from: 'at',
        },
      });
    },
    goToEvaluationDiscution(item) {
      this.$store.dispatch('setSelectedAt', item.peiAtServiceId);
      delete item.documents;
      sessionStorage.setItem('ReferralData', JSON.stringify(item));
      router.push({
        name: 'EvaluationDiscussionAT',
        params: {
          ...item,
          referralId: item.peiAtServiceId,
        },
      });
    },
    goToReferralAtDiscussionSchool(item) {
      this.$store.dispatch('setSelectedAt', item.peiAtServiceId);
      delete item.documents;
      sessionStorage.setItem('ReferralData', JSON.stringify(item));
      router.push({
        name: 'ReferralATDiscussionSchool',
        params: {
          ...item,
        },
      });
    },
    loadDocumentsForReferral(referral) {
      this.$set(referral, 'estipulacion80', {});
      this.$set(referral.estipulacion80, 'uploaded', false);

      this.$set(referral, 'minuta', {});
      this.$set(referral.minuta, 'uploaded', false);

      this.$set(referral, 'minutaDiscusionEvaluacion', {});
      this.$set(referral.minutaDiscusionEvaluacion, 'uploaded', false);

      this.$ApiGet(
        `api/atservice/documentAttachments/${referral.peiAtServiceId}`
      ).then((response) => {
        this.$set(
          referral,
          'estipulacion80',
          response.data.find(
            (d) => d.documentTypeId == equipmentDocumentTypes.ESTIPULACION80
          )
        );
        this.$set(
          referral,
          'minuta',
          response.data.find(
            (d) => d.documentTypeId == equipmentDocumentTypes.MINUTA
          )
        );

        this.$set(
          referral,
          'minutaDiscusionEvaluacion',
          response.data.find(
            (d) =>
              d.documentTypeId ==
              equipmentDocumentTypes.MINUTADISCUSIONEVALUACION
          )
        );

        if (
          response.data.find(
            (d) => d.documentTypeId == equipmentDocumentTypes.ESTIPULACION80
          ) !== undefined
        ) {
          this.$set(referral.estipulacion80, 'uploaded', true);
        }

        if (
          response.data.find(
            (d) => d.documentTypeId == equipmentDocumentTypes.MINUTA
          ) !== undefined
        ) {
          this.$set(referral.minuta, 'uploaded', true);
        }

        if (
          response.data.find(
            (d) =>
              d.documentTypeId ==
              equipmentDocumentTypes.MINUTADISCUSIONEVALUACION
          ) !== undefined
        ) {
          this.$set(referral.minutaDiscusionEvaluacion, 'uploaded', true);
        }
      });
    },
    openFile(documentType) {
      switch (documentType) {
        case 'estipulacion80':
          this.$refs.fileEstipulacion80.click();
          break;

        case 'minuta':
          this.$refs.fileMinuta.click();
          break;

        case 'minutaDiscusionEvaluacion':
          this.$refs.fileMinutaDiscusionEvaluacion.click();
          break;
      }
    },
    onFileSelected(referral, documentType) {
      const capitalizedDocumentType =
        documentType.charAt(0).toUpperCase() + documentType.substring(1);

      let files = this.$refs[`file${capitalizedDocumentType}`].files;

      if (files.length > 0) {
        this.$set(referral, documentType, {});
        referral[documentType].documentTitle = files[0].name;
      } else {
        this.$set(referral, documentType, {});
        referral[documentType].documentTitle = '';
        referral[documentType].documentName = '';
      }
    },
    canShowSaveCancelButtons(referral) {
      let isEstipulacion80Uploaded =
        referral.estipulacion80 && referral.estipulacion80.uploaded;
      let isMinutaUploaded = referral.minuta && referral.minuta.uploaded;

      if (this.isDeliveredPendingSignatureStatus && this.hasSignedPei) {
        return true;
      }

      return !(isEstipulacion80Uploaded && isMinutaUploaded);
    },
    canShowSaveCancelMinutaAtButtons(referral) {
      let isMinutaDiscusionEvaluacionUploaded =
        referral.minutaDiscusionEvaluacion &&
        referral.minutaDiscusionEvaluacion.uploaded;

      return !isMinutaDiscusionEvaluacionUploaded;
    },

    async saveReplacedDocuments(referral) {
      const estipulacion80Files = this.$refs?.fileEstipulacion80?.files;
      const minutaFiles = this.$refs?.fileMinuta?.files;
      const discussionEvaluationFiles = this.$refs
        ?.fileMinutaDiscusionEvaluacion?.files;

      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        this.ShowToast(
          'Error',
          'Favor de completar la información solicitada.',
          'error'
        );
        return;
      }

      if (referral.estipulacion80) {
        if (!referral.estipulacion80.documentTitle) {
          this.ShowToast(
            '',
            'Debe subir un documento "Estipulación 80 Firmada"  o cancelar acción.',
            'error'
          );
          return false;
        }
      }

      if (referral.minuta) {
        if (!referral.minuta.documentTitle) {
          this.ShowToast(
            '',
            'Debe subir un documento "Minuta de Entrega de Equipo Firmada"  o cancelar acción.',
            'error'
          );
          return false;
        }
      }

      if (referral.minutaDiscusionEvaluacion) {
        if (!referral.minutaDiscusionEvaluacion.documentTitle) {
          this.ShowToast(
            '',
            'Debe subir un documento "Minuta de Discusión de Evaluación de AT Firmada"  o cancelar acción.',
            'error'
          );
          return false;
        }
      }

      if (estipulacion80Files?.length > 0) {
        await this.uploadDocument(referral, 'estipulacion80', true);
      }
      if (minutaFiles?.length > 0) {
        await this.uploadDocument(referral, 'minuta', true);
      }
      if (discussionEvaluationFiles?.length > 0) {
        await this.uploadDocument(referral, 'minutaDiscusionEvaluacion', true);
      }

      this.search(0);
      this.ShowToast(
        '',
        'El documento ha sido reemplazado exitosamente.',
        'success'
      );
    },

    async saveDocuments(referral) {
      const estipulacion80Files = this.$refs.fileEstipulacion80.files;
      const minutaFiles = this.$refs.fileMinuta.files;

      if (estipulacion80Files.length > 0) {
        await this.uploadDocument(referral, 'estipulacion80');
      }

      if (minutaFiles.length > 0) {
        await this.uploadDocument(referral, 'minuta');
      }

      if (this.isDeliveredPendingSignatureStatus && !this.hasSignedPei) {
        this.ShowToast('', 'El referido debe contar con PEI firmado.', 'error');
        return;
      }

      this.changeReferralStatus(referral);
    },

    uploadDocument(referral, documentType, isReplacement = false) {
      return new Promise((resolved) => {
        let attachment = {};
        let documentTypeId = 0;
        let comment = null;

        switch (documentType) {
          case 'estipulacion80':
            attachment = this.$refs.fileEstipulacion80.files[0];
            documentTypeId = equipmentDocumentTypes.ESTIPULACION80;
            comment = this.comments?.estipulacion80.text;
            break;

          case 'minuta':
            attachment = this.$refs.fileMinuta.files[0];
            documentTypeId = equipmentDocumentTypes.MINUTA;
            comment = this.comments?.minuta.text;
            break;

          case 'minutaDiscusionEvaluacion':
            attachment = this.$refs.fileMinutaDiscusionEvaluacion.files[0];
            documentTypeId = equipmentDocumentTypes.MINUTADISCUSIONEVALUACION;
            comment = this.comments?.minutaDiscusionEvaluacion.text;
            break;
        }

        if (attachment.type == 'application/pdf') {
          let files = new FormData();
          referral.selectedFile = attachment.name;
          files.append(documentTypeId, attachment, attachment.name);

          files.append('comment', comment || '');
          http
            .post(
              `api/atservice/${referral.peiAtServiceId}/uploadDocument`,
              files,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              }
            )
            .finally(() => {
              let documentDescription = '';

              switch (documentType) {
                case 'estipulacion80':
                  documentDescription = 'Estipulación 80 Firmada';
                  break;

                case 'minuta':
                  documentDescription = 'Minuta de Entrega de Equipo Firmada';
                  break;

                case 'minutaDiscusionEvaluacion':
                  documentDescription =
                    'Minuta de Discusión de Evaluación de AT Firmada';
                  break;
              }

              this.$set(referral, documentType, {});
              referral[documentType].documentTitle = attachment.name;
              referral[documentType].documentName = documentDescription;
              this.$set(referral[documentType], 'uploaded', true);
              this.clearFileInput(documentType);

              resolved();
            });
        }
      });
    },
    downloadDocument(referral, documentType) {
      generalService.documentsDownloadFiles(
        referral.peiAtServiceId,
        this.getIdOfDocumentType(documentType)
      );
    },
    canDeleteDocument(referral) {
      return (
        [
          peiAtServiceStatus.PendienteDeDiscusionEscuela,
          peiAtServiceStatus.EntregadoPendienteFirma.includes(
            referral.serviceStatusId
          ),
        ] && referral.hasServedSchoolDate
      );
    },
    deleteDocument(referral, documentType) {
      const documentTypeId = this.getIdOfDocumentType(documentType);

      http
        .delete(
          `api/atservice/${referral.peiAtServiceId}/documentType/${documentTypeId}`
        )
        .finally(() => {
          this.$set(referral, documentType, {});
          referral[documentType].documentTitle = '';
          referral[documentType].documentName = '';
          this.$set(referral[documentType], 'uploaded', false);
        });
    },

    async changeReferralStatus(referral) {
      await http
        .patch(`api/atservice/${referral.peiAtServiceId}/changeStatus`, {
          peiAtServiceId: referral.peiAtServiceId,
          peiAtServiceCurrentStatusId: referral.serviceStatusId,
        })
        .then(() => {
          //re-search data to update
          this.search(0);
        });
    },

    getIdOfDocumentType(documentTypeName) {
      switch (documentTypeName) {
        case 'estipulacion80':
          return equipmentDocumentTypes.ESTIPULACION80;
        case 'minuta':
          return equipmentDocumentTypes.MINUTA;
        case 'minutaDiscusionEvaluacion':
          return equipmentDocumentTypes.MINUTADISCUSIONEVALUACION;
      }
    },
    clearFileInput(documentType) {
      const capitalizedDocumentType =
        documentType.charAt(0).toUpperCase() + documentType.substring(1);

      this.$refs[`file${capitalizedDocumentType}`].value = null;
    },
    discardSelectedFile(referral, documentType) {
      this.clearFileInput(documentType);
      this.$set(referral, documentType, {});
      referral[documentType].documentTitle = '';
      referral[documentType].documentName = '';

      this.$set(referral[documentType], 'uploaded', false);

      this.comments[documentType].text = null;
      this.comments[documentType].enabled = true;
    },
    deleteOrDiscard(referral, documentType) {
      if (referral[documentType] && referral[documentType].uploaded) {
        this.deleteDocument(referral, documentType);
      } else {
        this.discardSelectedFile(referral, documentType);
      }
    },
    showIfContainStatus(statuses, statusId) {
      return statuses.some((id) => id === statusId);
    },
    async getAtServiceReport(item) {
      const { data } = await this.$ApiGet(
        '/api/report/atservice/' + item.peiId
      );

      if (data.content == null) {
        this.ShowToast('', 'El reporte no pudo ser generado', 'error');
        return;
      }
      generalService.documentDownloadReport(data.content, data.filename);
    },
    async onSaveDocument(documents, item) {
      let attachment = documents[0].document;
      let documentId = documents[0].documentId ?? null;
      let documentTypeId = documents[0].documentTypeId;

      let formData = objectToFormData(
        {
          peiAtServiceId: this.item.peiAtServiceId,
          peiAtServiceCurrentStatusId: this.item.serviceStatusId,
          documentTypeId: documentTypeId,
          documentId: documentId,
        },
        { indices: true }
      );

      formData.append('document', attachment);

      await atService
        .uploadEvaluationDocument(this.item.peiAtServiceId, formData)
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso.',
            'El documento ha sido anejado exitosamente.',
            'success'
          );
          item.showMinutaAtDocument = false;

          //re-search data to update
          this.search(0);
        });
    },
    async validatePeiSigned() {
      try {
        const { data } = await generalService.getAtLastSignedPeiDocument(
          this.item.peiAtServiceId
        );
        this.signedPeiDocumentId = data;
      } catch {}
    },
    getSignedPeiDocument() {
      DocumentsService.downloadFromServer(this.signedPeiDocumentId);
    },
    async goToStudentPeiHistory() {
      await this.$store.dispatch('$_student/setStudentDetails', {
        student: this.student,
        studentId: this.student.studentId,
        viewStudentInfo: true,
        selectThisStudent: true,
      });
      this.$store.commit('$_student/showStudentBox', true);
      this.$router.push({
        name: 'studentHistory',
      });
    },
    async getStudent() {
      const { data: response } = await studentService.getBySie(
        this.item.studentSieId,
        false
      );
      this.student = response;
    },
    async onCancelAddCommentHandler(item) {
      item.expanded = false;
      item.showAddComment = false;
    },
    onCancelRevertEvaluationDiscussionHandler(item) {
      item.expanded = false;
      item.RevertEvaluationDiscussion = false;
      this.revertEvaluationDiscussionComment = null;
    },
    async onSaveAddCommentHandler(payload, item) {
      try {
        let formData = objectToFormData(
          {
            studentSieId: item.studentSieId,
            categoryTypeId: commentTypes.ReferidosAsistenciaTecnologica,
            description: payload.comment,
          },
          { indices: true }
        );

        if (payload.file) {
          formData.append('attachment', payload.file);
        }

        await studentService.saveComment(formData);

        this.ShowToast(
          'Completado',
          'Su información ha sido procesada exitosamente.',
          'success'
        );
        item.expanded = false;
        item.showAddComment = false;
      } catch (e) {
        this.ShowToast('', e.message || 'error', 'error');
      }
    },
    async onSaveRevertEvaluationDiscussionHandler(item) {
      if (!this.revertEvaluationDiscussionComment?.trim()) {
        await this.$refs?.revertEvaluationDiscussionFormValidator?.validate();
        this.ShowToast('Alerta', 'El campo es requerido.', 'error');
        return;
      }

      let message = `¿Está seguro que desea revertir la evaluación?`;

      if (this.isDeliveredPendingSignatureStatus)
        message = `¿Está seguro que desea revertir la Discusión de Escuela?`;

      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        message,
        'Sí',
        'No'
      );

      if (!confirmed) return;

      const payload = {
        peiAtServiceId: item.peiAtServiceId,
        comment: this.revertEvaluationDiscussionComment,
      };

      if (this.isDiscussedSignPendingStatus) {
        await studentService
          .revertEvaluationDiscussion(payload)
          .then(() => {
            this.ShowToast(
              'Proceso Exitoso.',
              'El estatus se ha revertido exitosamente.',
              'success'
            );
          })
          .catch((e) => {
            this.ShowToast('', e.message || 'error', 'error');
          });
      } else if (this.isDeliveredPendingSignatureStatus) {
        await studentService
          .revertSchoolDiscussion(payload)
          .then(() => {
            this.ShowToast(
              'Proceso Exitoso.',
              'El estatus se ha revertido exitosamente.',
              'success'
            );
          })
          .catch((e) => {
            this.ShowToast('', e.message || 'error', 'error');
          });
      }

      this.search(0);
      this.revertEvaluationDiscussionComment = null;
      item.expanded = false;
      item.RevertEvaluationDiscussion = false;
    },
  },
};
</script>
<style scoped src="@/assets/css/component/badge.css"></style>

<style scoped>
@import '../../../assets/css/info-evaluations.css';
.content-header {
  border: 1px solid #f7f7f7;
  background-color: #f7f7f7f7;
}

.dropdown-division {
  border-top: 2px solid #f7f7f7;
  width: auto;
}

.style-chooser .vs__search::placeholder {
  color: black !important;
}
.status-badge {
  font: Bold 16px/19px Lato;
  color: #11291b;
  padding: 0px 32px;
  font-weight: bolder;
}
.student-label {
  font: 14px/28px Lato;
  color: #727272;
}
.student-name {
  font: 16px/28px Lato;
  color: #11291b;
}
.border-right-2 {
  border-right: 1px solid rgba(114, 114, 114, 0.22);
  /* opacity:0.22; */
}
.icon-stack {
  width: 2em;
  cursor: pointer;
}
.green {
  color: #2db782;
}
.icon-orange {
  color: #ff7058;
}
.dark-gray {
  color: #3f5b60;
}
.expanded {
  color: #2db782;
}
.collapsed {
  color: #3f5b60;
}
.row-details {
  transition: 350ms ease-out;
  overflow: hidden;
}
.orange-icon {
  color: #ff7058;
}
.tag-badge-custom {
  width: 183px;

  border-radius: 26px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
}
.double {
  transform: scale(1.3);
}
.document-label {
  font: Bold 16px/18px Lato;
  font-weight: bold !important;
  color: #11291b;
}
.document-description {
  font: 18px Lato;
  font-weight: 300 !important;
  color: #11291b;
}
.docs {
  height: 300px !important;
}
.text-underline {
  text-decoration: underline;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
  font: 700 14px/17px Lato;
}
.separator .text {
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 21px;

  width: 146px;
  height: 32px;
  font: Bold 17px/23px Lato;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #b5c3bc;
}
.separator::before {
  margin-right: 33px;
}
.separator::after {
  margin-left: 33px;
}

.actions {
  height: 33px;
  width: 33px;
}

::v-deep .actions > i {
  padding-left: 0px !important;
  vertical-align: text-top !important;
}
@media (min-width: 1552px) {
  .responsive-max-width {
    width: max-content;
  }
}
</style>
